import styled from 'styled-components'

const Displayer = styled.div`
    display: ${(props) => (props.display ? props.display : 'flex')};
    transition: all 0.2s;
`

export default Displayer
